var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUmbrella01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12143_71703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.49998 9.7C8.49998 10.418 7.94034 11 7.24998 11C6.55963 11 5.99998 10.418 5.99998 9.7V6M1.06314 5.20313C1.44474 2.82045 3.50977 1 5.99998 1C8.4902 1 10.5552 2.82045 10.9368 5.20313C10.9741 5.43569 10.9927 5.55197 10.9459 5.67617C10.9087 5.77499 10.8176 5.88182 10.726 5.93419C10.6107 6 10.4738 6 10.2 6H1.79998C1.52616 6 1.38925 6 1.27401 5.93419C1.18232 5.88182 1.09123 5.77499 1.05403 5.67617C1.00727 5.55197 1.02589 5.43569 1.06314 5.20313Z",
    stroke: "#00245C",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12143_71703"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUmbrella01);
export default __webpack_public_path__ + "static/media/umbrella-01.d33750f66ec7f6fc1a51c79858532fd2.svg";
export { ForwardRef as ReactComponent };